import { render, staticRenderFns } from "./pangzhan.vue?vue&type=template&id=196955be&scoped=true"
import script from "./pangzhan.vue?vue&type=script&lang=js"
export * from "./pangzhan.vue?vue&type=script&lang=js"
import style0 from "./pangzhan.vue?vue&type=style&index=0&id=196955be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196955be",
  null
  
)

export default component.exports